import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

import companyLogo from "../../../../assets/images/tektree-logo-png-1.svg";
import QbModal from "../Modals/QbModal";
import VoidModal from "../Modals/VoidModal";
import DeleteConformationModal from "../Modals/DeleteConformationModal";
import ResendModal from "../Modals/ResendModal";
import { invoicesDetailsActivityTableData } from "../../../../assets/data/candidatesData";
import {
  Backdrop,
  Button,
  Chip,
  CopyToClipboard,
  DevNote,
  Divider,
  DocumentsList,
  HeaderCard,
  InfoCardNewAdv,
  InfoTimeCard,
  InfoTimeCardAdv,
  InvoicesHeader,
  KeyValue,
  LogoLoader,
  Modal,
  NewTable,
  NewTableAdv,
  PageHeader,
  PageTitle,
  PdfGenerator,
  showToast,
  StatusTags,
  TableAdv,
  Tag,
} from "../../../../components";
import { dateFormator, formatNumber, mapTableRows } from "../../../../utils";
import ReceivePayment from "./ReceivePayment";
import EditInvoice from "./EditInvoice";
import { useDispatch, useSelector } from "react-redux";
import { useLoginUser } from "../../../../hooks/useLoginUser";
import QbAnimationLoading from "../../../../components/Module/Invoices/InvoiceModals/QbAnimationLoading";
import { WORKFORCE_API_URL } from "../../../../redux/apiConfig";
import {
  addInvoicesStart,
  getCurrentInvoiceStart,
} from "../../../../redux/slices/invoices/invoicesSlice";
import {
  clearPayments,
  qbApiStart,
} from "../../../../redux/slices/quickBooks/quickBooksSlice";
import { formatCurrency } from "../../../../utils/stringUtils";
import { getEmailTemplate, sendEmail } from "../../../../utils/wf/email";
import InvoiceHeader from "../InvoicePdfComponents/InvoiceHeader";
import InvoiceContent from "../InvoicePdfComponents/InvoiceContent";
import InvoiceFooter from "../InvoicePdfComponents/InvoiceFooter";
import TableHeader from "../../ComponentsList/List/PdfGeneratorList/Invoice/TableHeader";
import InvoiceData from "../../ComponentsList/List/PdfGeneratorList/Invoice/InvoiceData";
import generatePdf from "../../../../components/PdfGenerator/generatePdf";
import { handleTimesheetDownload } from "../../Employee/EmployeeProfile/Timesheets/TimesheetDetails";
import { exactUTCDate } from "../../../../utils/dateFormator";
import dayjs from "dayjs";

let baseUrl = WORKFORCE_API_URL;

export const handleInvoiceDownload = async (updatedData) => {
  try {
    await generatePdf({
      initialLayout: "portrait",
      items: updatedData.invoiceDeta?.invoicedItems || [],
      // Render 7-day rows: pass the full items array and current index
      rowRenderer: (item, index) => InvoiceData(item, index),
      header: () => <InvoiceHeader data={updatedData} />,

      headerTwo: () => <InvoiceHeader data={updatedData} type="sub" />,
      contentTop: () => <InvoiceContent data={updatedData} type="top" />,
      contentBottom: () => <InvoiceContent data={updatedData} type="bottom" />,
      tableHeader: () => <TableHeader />,
      footer: () => <InvoiceFooter data={updatedData} showText={false} />,
      footerTwo: () => <InvoiceFooter data={updatedData} type="sub" showText={false} />,
      backgroundLogo: updatedData?.company?.backgroundLogo,
      fileName: `Invoice-${updatedData.invoiceDeta?.invoiceNumber || ""}`,
    });
  } catch (error) {
    throw error;
  }
};

const InvoiceDetails = ({
  onBack,
  invoiceData,
  setEditInvoice,
  setReceivePayment,
  removeButtonForPreview = false,
  isPublicView = false,
  companyLogo: propCompanyLogo,
}) => {
  const dispatch = useDispatch();
  const { payments, loading: paymentsLoading } = useSelector(
    (state) => state.quickBooks,
  );
  const { userData: loginUserData } = useLoginUser();
  const loginUserUiid = loginUserData?.uiid;
  const { currentInvoices, loading } = useSelector((state) => state.invoices);
  const [isVoidModalOpen, setIsVoidModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isResendModal, setISResendModal] = useState(false);
  const [isQbModalOpen, setIsQbModalOpen] = useState(false);
  const [attachmentModal, setAttachmentModal] = useState(false);
  const [showReceivePayment, setShowReceivePayment] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isMailLoading, setIsMailLoading] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);

  const navigate = useNavigate();

  const tableData = currentInvoices?.serviceSummary || [];
  const columns = [
    {
      key: "ss",
      label: "Service Summary",
      render: (row) => (
        <div className="flex items-center gap-3 group">
          <div>{row?.ss}</div>
          <div
            className={`flex items-center opacity-0 group-hover:opacity-100 transition-opacity duration-200 ${
              row?.ss === "-" ? "invisible" : "visible"
            }`}
          >
            <CopyToClipboard
              tooltipPosition={"right"}
              title={"Statement Memo"}
              content={row?.ss}
            />
          </div>
        </div>
      ),
    },
    {
      key: "activity",
      label: "Activity",
      // render: (row) => <div>{row.activity ? `${row.activity}` : "-"}</div>
      render: (row) => (
        <div className="flex items-center gap-3 group">
          <div>{row?.activity}</div>
          <div
            className={`flex items-center opacity-0 group-hover:opacity-100 transition-opacity duration-200 ${
              row?.activity === "-" ? "invisible" : "visible"
            }`}
          >
            <CopyToClipboard
              tooltipPosition={"right"}
              title={"Statement Memo"}
              content={row?.activity}
            />
          </div>
        </div>
      ),
    },
    // {
    //   key: "accountType",
    //   label: "Account Type",
    // },
    // {
    //   key: "attachment",
    //   label: "Attachment",
    // },
    {
      key: "quantity",
      label: "Quantity(Hrs/Days)",
      render: (row) =>
        isNaN(row.quantity) ? "-" : Number(row.quantity).toFixed(2),
    },
    {
      key: "rate",
      label: "Rate",
    },
    {
      key: "amount",
      label: "Amount",
      width: "210px",
      render: (row) => <div>{formatCurrency(row.amount)}</div>,
    },
  ];

  const activityTableData = invoicesDetailsActivityTableData;
  const activityColumns = [
    {
      key: "dateAndTime",
      label: "Date & Time",
      render: (row) => dateFormator(row.dateAndTime, "datetime"),
    },
    {
      key: "description",
      label: "Description",
    },
    {
      key: "updatedBy",
      label: "UpdatedBy",
    },
  ];

  const mappedRows = mapTableRows(tableData, columns);
  const activityRows = mapTableRows(activityTableData, activityColumns);

  useEffect(() => {
    if (currentInvoices?.qbPayments?.length > 0) {
      const arrayOfQbPaymentIds = (currentInvoices?.qbPayments || [])?.map(
        (payment) => Number(payment.txnId),
      );
      if (arrayOfQbPaymentIds.length > 0) {
        dispatch(
          qbApiStart({
            method: "GET",
            entity: "payments",
            suppressToast: true,
            params: {
              fil: JSON.stringify({
                Id: { type: "IN", value: arrayOfQbPaymentIds },
              }),
              ret: "Id TotalAmt TxnDate",
            },
          }),
        );
      }
    }
    return () => {
      dispatch(clearPayments());
    };
  }, [JSON.stringify(currentInvoices?.qbPayments)]);

  const closeVoidModal = () => {
    setIsVoidModalOpen(false);
  };
  const attachments = (currentInvoices?.serviceSummary ?? [])
    .flatMap((item) =>
      Array.isArray(item.attachments) ? item.attachments : [],
    )
    .filter((path) => path); // Removes any falsy values like empty strings
  const combineAttachments =
    attachments?.map((data) => ({
      filePath: data,
      name: "summeryAttach",
    })) || [];
  if (currentInvoices?.timesheetRef?.length > 0) {
    let timesheetsAtt =
      currentInvoices?.timesheetRef
        ?.flatMap((ts) => ts?.id)
        ?.flatMap((ts2) => ts2?.attachments)
        ?.map((link) => ({ filePath: link, name: "Timesheet Attachment" })) ||
      [];
    if (timesheetsAtt.length > 0) {
      combineAttachments.push(...timesheetsAtt);
    }
  }

  const [forceRerenderKey, setForceRerenderKey] = useState(0);
  const forceRerender = () => {
    setForceRerenderKey((prevKey) => prevKey + 1);
  };
  const handleQB = async (entity = "invoices") => {
    const isEntitySynced = Boolean(currentInvoices?.clientId?.qbSync?.id);
    const clientData = currentInvoices?.clientId || {};

    const buildClientPayload = (data) => ({
      postActions: ["AddQBToClient"],
      payload: {
        // businessName: data.businessName || "",
        businessName: data?.businessName || "",
        uiid: data?.uiid || null,
        email: data?.email || [],
        phone: (data?.phone || []).map((p) => ({
          code: p.code || "",
          number: String(p.number || ""),
        })),
        roleContacts: (data?.roleContacts || []).map((rc) => ({
          role: rc.role || "",
          email: rc.email || [],
          phone: (rc.phone || []).map((p) => ({
            code: p.code || "",
            number: String(p.number || ""),
          })),
        })),
        federalId: data?.federalId || "",
        website: data?.website || "",
        recordStatus: data?.recordStatus || null,
        ownership: data?.ownership || null,
        generalInfo: data?.generalInfo || null,
        contacts: data?.contacts || [],
        additionalInfo: data?.additionalInfo || "",
        documents: (data?.documents || []).map((doc) => ({
          placement: doc.placement || [],
          list: doc.list || [],
        })),
        placements: data?.placements || [],
        addedBy: data?.addedBy || null,
        addedOn: data?.addedOn || new Date().toISOString(),
      },
    });

    const buildInvoicePayload = () => {
      const obj = currentInvoices;
      return {
        ...(obj?.qbSync?.id && { qbSync: obj?.qbSync }),
        uiid: obj?.uiid,
        // clientId: 24,
        clientId: obj?.clientId.uiid || null,
        invoiceCreatedBy: obj?.invoiceCreatedBy || null,
        invoiceNum: obj?.invoiceNum || null,
        poNum: obj?.poNum || null,
        type: obj?.type || null,
        frequency: obj?.frequency || null,
        frequencyPeriod: obj?.frequencyPeriod || null,
        status: obj?.status || null,
        inclPOEmail: obj?.inclPOEmail || null,
        employeeId: obj?.employeeId._id || null,
        jobId: obj?.jobId._id || null,
        timesheet: obj?.timesheet || null,
        address: {
          billing: {
            ...(obj?.address.billing || null),
            zipCode: obj?.address.billing.zipCode || "",
          },
          from: {
            ...(obj?.address.from || null),
            zipCode: obj?.address.from.zipCode || "",
          },
        },
        netTerms: obj?.netTerms || null,
        // invoiceDate:
        //   invoiceDate >= minAllowed
        //     ? invoiceDate.toISOString()
        //     : minAllowed.toISOString(),
        invoiceDate: obj?.invoiceDate || null,
        shippedDate: obj?.shippedDate || null,
        dueDate: obj?.dueDate || null,
        location: obj?.location || null,
        amounts: obj?.amounts || null,
        recipients: obj?.recipients || null,
        serviceSummary: obj?.serviceSummary.map(
          ({ ss, activity, quantity, rate, attachments, inclMailAttch }) => ({
            ss,
            activity,
            quantity,
            rate,
            amount: +(Number(quantity) * Number(rate)).toFixed(2),
            attachments,
            inclMailAttch,
          }),
        ),
        finalBill: {
          subTotal: obj?.finalBill.subTotal || null,
          discounts: obj?.finalBill.discounts.map(({ name, type, value }) => ({
            name,
            type,
            value,
          })),
        },
        notes: obj?.notes || null,
        inclNotesPdf: obj?.inclNotesPdf || null,
        memo: obj?.memo || null,
        memoPeriod: obj?.memoPeriod || null,
        additionalInfo: obj?.additionalInfo || null,
        currency: obj?.currency || null,
        addedBy: obj?.addedBy || null,
        addedOn: obj?.addedOn || null,
        attachments: [],
        payableTo: "",
        category: "",
        class: "",
      };
    };

    try {
      setIsLoading(true);
      if (!isEntitySynced) {
        showToast("Entity is not synced to QuickBooks", "error", 2000);

        const clientPayload = buildClientPayload(clientData);

        try {
          const res = await axios.post(
            `${baseUrl}/qb/customers`,
            clientPayload,
            {
              headers: { "Content-Type": "application/json" },
              withCredentials: true,
            },
          );
          // const dataForClientUpdate = res?.data?.data;
          // //update qb data to client
          // dispatch(
          //   updateClientStart({
          //     uiid: clientData.uiid,
          //     coll: "Client",
          //     payload: [
          //       {
          //         type: "SET",
          //         value: {
          //           qbSync: {
          //             synced: true,
          //             id: dataForClientUpdate.Id,
          //             token: dataForClientUpdate.SyncToken,
          //             lastSync: new Date().toISOString(),
          //           },
          //         },
          //       },
          //     ],
          //   })
          // );
          showToast("Synching Entity With QB", "success", 2000);
        } catch (syncErr) {
          console.error("API Error:", syncErr.response);
          showToast(
            syncErr?.response?.data?.error || "Failed to Sync Entity With QB",
            "error",
            10000,
          );
          return; // Stop here if client sync fails
        }
      }
      const isInvoiceSynced = Boolean(currentInvoices?.qbSync?.id);
      if (!isInvoiceSynced) {
        showToast("Invoice is not synced to QuickBooks", "error", 2000);
        const invoicePayload = buildInvoicePayload();

        const res = await axios.post(
          `${baseUrl}/qb/invoices`,
          {
            postActions: ["AddQBToInvoice"],
            payload: invoicePayload,
          },
          {
            withCredentials: true,
            headers: { "Content-Type": "application/json" },
          },
        );
        const dataForInvoiceUpdate = res?.data?.data;
        let failedUploads = 0;

        if (
          invoicePayload?.serviceSummary?.length > 0 ||
          invoicePayload?.serviceSummary?.some(
            ({ attachments }) => attachments?.length > 0,
          )
        ) {
          for (const service of invoicePayload.serviceSummary) {
            if (service?.attachments?.length > 0) {
              for await (const file of service.attachments) {
                try {
                  const filesRes = await axios.post(
                    `${baseUrl}/qb/uploads`,
                    {
                      payload: {
                        uiid: invoicePayload.uiid,
                        fileName: service?.ss,
                        inclToMail: !!service.inclMailAttch,
                        parentRef: {
                          entity: "Invoice",
                          id: res?.data?.data?.response?.Id,
                        },
                        attachment: file,
                      },
                    },
                    {
                      headers: { "Content-Type": "application/json" },
                      withCredentials: true,
                    },
                  );
                } catch (err) {
                  failedUploads++;
                }
              }
            }
          }
        }

        if (failedUploads > 0) {
          dispatch(
            addInvoicesStart({
              coll: "Invoice",
              uiid: invoicePayload?.uiid,
              qbId: res?.data?.data?.response?.Id,
              syncFromQB: true,
              supressToast: true,
              onSuccess: () => {
                // forceRerender();
                dispatch(
                  getCurrentInvoiceStart({
                    filters: {
                      uiid: { type: "NONE", value: currentInvoices.uiid },
                    },
                    coll: "Invoice",
                    ref: "Client Employee Placement Timesheet",
                    // incl: ["businessName uiid", "firstName lastName"],
                    incl: ["", "firstName lastName", "", "attachments"],
                  }),
                );
              },
            }),
          );
          showToast(
            `${failedUploads} attachment${
              failedUploads > 1 ? "s" : ""
            } failed to upload`,
            "info",
            3000,
          );
        } else {
          dispatch(
            addInvoicesStart({
              coll: "Invoice",
              uiid: invoicePayload?.uiid,
              qbId: res?.data?.data?.response?.Id,
              syncFromQB: true,
              supressToast: true,
              onSuccess: () => {
                // forceRerender();
                dispatch(
                  getCurrentInvoiceStart({
                    filters: {
                      uiid: { type: "NONE", value: currentInvoices.uiid },
                    },
                    coll: "Invoice",
                    ref: "Client Employee Placement Timesheet",
                    // incl: ["businessName uiid", "firstName lastName"],
                    incl: ["", "firstName lastName", "", "attachments"],
                  }),
                );
              },
            }),
          );
        }

        if (res.status === 200) {
          showToast("Invoice Synced to QuickBooks", "success", 5000);
          setIsQbModalOpen(true);
        }
      } else {
        // showToast("Invoice is already synced to QuickBooks", "info", 5000);
        showToast("Updating the already synced invoice", "info", 5000);
        const invoicePayload = buildInvoicePayload();

        const res = await axios.post(
          `${baseUrl}/qb/invoices`,
          {
            update: true,
            postActions: ["AddQBToInvoice"],
            payload: invoicePayload,
          },
          {
            withCredentials: true,
            headers: { "Content-Type": "application/json" },
          },
        );
        let failedUploads = 0;

        // if (
        //   invoicePayload?.serviceSummary?.length > 0 ||
        //   invoicePayload?.serviceSummary?.some(
        //     ({ attachments }) => attachments?.length > 0
        //   )
        // ) {
        //   for (const service of invoicePayload.serviceSummary) {
        //     if (service?.attachments?.length > 0) {
        //       for await (const file of service.attachments) {
        //         try {
        //           const filesRes = await axios.post(
        //             `${baseUrl}/qb/uploads`,
        //             {
        //               payload: {
        //                 uiid: invoicePayload.uiid,
        //                 fileName: service?.ss,
        //                 inclToMail: !!service.inclMailAttch,
        //                 parentRef: {
        //                   entity: "Invoice",
        //                   id: invoicePayload?.qbSync?.id,
        //                 },
        //                 attachment: file,
        //               },
        //             },
        //             {
        //               headers: { "Content-Type": "application/json" },
        //               withCredentials: true,
        //             }
        //           );
        //         } catch (err) {
        //           failedUploads++;
        //         }
        //       }
        //     }
        //   }
        // }

        // if (failedUploads > 0) {
        //   showToast(
        //     `${failedUploads} attachment${
        //       failedUploads > 1 ? "s" : ""
        //     } failed to upload`,
        //     "info",
        //     3000
        //   );
        // }
        // dispatch(
        //   addInvoicesStart({
        //     coll: "Invoice",
        //     uiid: invoicePayload?.uiid,
        //     qbId: invoicePayload?.qbSync?.id,
        //     syncFromQB: true,
        //     supressToast: true,
        //   })
        // );
        if (res.status === 200) {
          // showToast("Invoice Synced to QuickBooks", "success", 5000);
          setIsQbModalOpen(true);
        }
      }
    } catch (error) {
      console.error("qb error", error);
      const errMsg = error?.response?.data?.error || "Unknown Error";
      showToast(errMsg, "error", 10000);
    } finally {
      dispatch(
        getCurrentInvoiceStart({
          filters: { uiid: { type: "NONE", value: currentInvoices.uiid } },
          coll: "Invoice",
          ref: "Client Employee Placement Timesheet",
          // incl: ["businessName uiid", "firstName lastName"],
          incl: ["", "firstName lastName", "", "attachments"],
        }),
      );
      setIsLoading(false);
    }
  };
  const handleQbSync = async () => {
    if (!currentInvoices?.qbSync?.id) {
      showToast("Please update the invoice first", "info", 3000);
      return;
    }
    if (!currentInvoices?.clientId?.qbSync?.id) {
      showToast("Please Sync the Client First", "info", 3000);
      return;
    }

    try {
      setIsLoading(true);
      await new Promise((resolve, reject) => {
        dispatch(
          addInvoicesStart({
            coll: "Invoice",
            uiid: currentInvoices?.uiid,
            qbId: currentInvoices?.qbSync?.id,
            syncFromQB: true,
            supressToast: true,
            onSuccess: () => {
              showToast("Invoice Synced to QuickBooks", "success", 5000);
              dispatch(
                getCurrentInvoiceStart({
                  filters: {
                    uiid: { type: "NONE", value: currentInvoices.uiid },
                  },
                  coll: "Invoice",
                  ref: "Client Employee Placement Timesheet",
                  // incl: ["businessName uiid", "firstName lastName"],
                  incl: ["", "firstName lastName", "", "attachments"],
                }),
              );
              resolve();
            },
            onError: (error) => {
              reject(error);
            },
          }),
        );
      });
    } catch (error) {
      console.error("QB Sync Error:", error);
      const errMsg =
        error?.error ||
        error?.response?.data?.error ||
        error?.message ||
        "Unknown Error";
      showToast(errMsg, "error", 10000);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSendMail = async (mailDetails) => {
    try {
      setIsMailLoading(true);
      if (!mailDetails?.emails?.selectedUsers?.length) {
        showToast("Please select at least one recipient", "error", 5000);
        setIsMailLoading(false);
        return;
      }
      const res = await sendEmail({
        to: mailDetails?.emails?.selectedUsers?.map((data) => data.email) || [],
        cc: mailDetails?.emails.ccUsers?.map((data) => data.email) || [],
        bcc: mailDetails?.emails.bccUsers?.map((data) => data.email) || [],
        subject: mailDetails.subject,
        html: mailDetails.body,
      },[
        ...(mailDetails?.attachments?.includes(1) ? [{
          type: "INVOICE_PDF",
          params: {
           invoiceId: currentInvoices?.uiid || null,
          },
        }] : []),
        ...(mailDetails?.attachments?.includes(2) ? [{
          type: "TS_FILES_PDF",
          params: {
            timesheetIds: currentInvoices?.timesheetRef?.flatMap((ref) => ref.id)?.map(ts => ts?.uiid) || [],
          }
        }] : []),
      ]);
      if (res?.success) {
        showToast("Email Sent", "success", 5000);
        setISResendModal(!isResendModal);
      }
    } catch (error) {
      showToast("Failed to send email", "error", 5000);
      console.error("Error sending email:", error);
    } finally {
      //compulasory to close mail modal and navigate after mail sent
      setIsMailLoading(false);
    }
  };

  const invoiceDownloader = async () => {
    try {
      setIsDownloading(true);
      const invoiceObj = {
        company: {
          name:"TekTree LLC",
          address:
            [
              currentInvoices?.address?.from?.address1,
              currentInvoices?.address?.from?.address2,
              currentInvoices?.address?.from?.city,
              currentInvoices?.address?.from?.state,
              currentInvoices?.address?.from?.country,
              currentInvoices?.address?.from?.zipCode,
            ]
              ?.filter(Boolean)
              ?.join(", ") || "-",
          contact:  "+1 (123) 456-7890",
          email:  "accounts@tektreeinc.com",
          website:  "www.tektreeinc.com",
          companyLogo: currentInvoices?.orgLogo || loginUserData?.organizationId?.logo?.company || propCompanyLogo || "",
          backgroundLogo: currentInvoices?.orgLogo || loginUserData?.organizationId?.logo?.company || propCompanyLogo || "",
          additionalInfo: currentInvoices?.additionalInfo || "",
        },
        invoiceDeta: {
          amounts: {
            invoiced: currentInvoices?.amounts?.invoiced || 0,
            due: currentInvoices?.amounts?.due || 0,
          },
          name: currentInvoices?.clientId?.businessName || "-",
          address:
            [
              currentInvoices?.address?.billing?.address1,
              currentInvoices?.address?.billing?.address2,
              currentInvoices?.address?.billing?.city,
              currentInvoices?.address?.billing?.state,
              currentInvoices?.address?.billing?.country,
              currentInvoices?.address?.billing?.zipCode,
            ]
              ?.filter(Boolean)
              ?.join(", ") || "-",
          invoiceNumber: currentInvoices?.invoiceNum || "-",
          invoiceDate: currentInvoices?.invoiceDate || "-",
          shippedDate: currentInvoices?.shippedDate || "-",
          netTerms: currentInvoices?.netTerms || "-",
          dueDate: currentInvoices?.dueDate || "-",
          invoicedItems:
            currentInvoices?.serviceSummary?.map((data) => ({
              item: data?.ss || "-",
              description: data?.activity || "-",
              quantity: data?.quantity || 0,
              price: data?.rate || 0,
              discount: 0,
            })) || [],
        },
      };
      const subTotal = invoiceObj?.invoiceDeta?.invoicedItems.reduce(
        (sum, item) =>
          sum + (item.quantity * item.price - (item.discount || 0)),
        0,
      );

      const updatedData = {
        ...invoiceObj,
        invoiceDeta: {
          ...invoiceObj?.invoiceDeta,
          subTotal: subTotal,
          discountTotal:
            invoiceObj?.invoiceDeta?.amounts?.invoiced - subTotal || 0,
          invoiceTotal: invoiceObj?.invoiceDeta?.amounts?.invoiced || 0,
          dueTotal: invoiceObj?.invoiceDeta?.amounts?.due || 0,
          currency: "USD",
        },
      };
      await handleInvoiceDownload(updatedData);
    } catch (error) {
      console.error("Error downloading invoice:", error);
    } finally {
      setIsDownloading(false);
    }
  };
  const timesheetDownloader = async () => {
    try {
      setIsDownloading(true);

      const timesheets = currentInvoices?.timesheetRef?.map(ref => ref.id).filter(Boolean) || [];
      if (timesheets.length === 0) {
        showToast("No timesheet data linked to this invoice", "info");
        return;
      }

      // Use the first timesheet or invoice period to define the range
      let startDateStr = currentInvoices?.memoPeriod?.from || timesheets[0]?.period?.from;
      let endDateStr = currentInvoices?.memoPeriod?.to || timesheets[timesheets.length - 1]?.period?.to;

      if (!startDateStr || !endDateStr) {
        const now = new Date();
        startDateStr = now.toISOString();
        endDateStr = now.toISOString();
      }

      // Consolidate entries
      const entryMap = new Map();
      timesheets.forEach(ts => {
        ts.dailyEntries?.forEach(entry => {
          entryMap.set(String(entry.date), entry);
        });
      });

      // Prepare date range aligned to Mon/Sun
      const from = new Date(startDateStr);
      const to = new Date(endDateStr);

      const start = new Date(from);
      const startDay = start.getDay();
      const diffToMonday = startDay === 0 ? -6 : 1 - startDay;
      start.setDate(start.getDate() + diffToMonday);

      const end = new Date(to);
      const endDay = end.getDay();
      const diffToSunday = endDay === 0 ? 0 : 7 - endDay;
      end.setDate(end.getDate() + diffToSunday);

      const filledData = [];

      for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
        const y = d.getFullYear();
        const m = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        const dateKey = `${y}${m}${day}`;

        const entry = entryMap.get(dateKey);

        filledData.push({
          date: d.toISOString(),
          standardTime: entry ? Number(entry.st || 0).toFixed(2) : null,
          totalBillableHours: entry ? Number(entry.tbh || 0).toFixed(2) : null,
          totalHours: entry ? Number(entry.th || 0).toFixed(2) : null,
        });
      }

      const totalValue = filledData.reduce((acc, item) => {
        acc.st += Number(item.standardTime) || 0;
        acc.tbh += Number(item.totalBillableHours) || 0;
        acc.th += Number(item.totalHours) || 0;
        return acc;
      }, { st: 0, tbh: 0, th: 0 });

      const emp = currentInvoices?.employeeId;
      const pdfData = {
        company: {
          name: "Company",
          address: [
            currentInvoices?.address?.from?.address1,
            currentInvoices?.address?.from?.address2,
            currentInvoices?.address?.from?.city,
            currentInvoices?.address?.from?.state,
            currentInvoices?.address?.from?.country,
            currentInvoices?.address?.from?.zipCode,
          ].filter(Boolean).join(", ") || "-",
          contact: "-",
          email: "-",
          website: "-",
          additionalInfo: currentInvoices?.additionalInfo,
        },
        client: {
          name: currentInvoices?.clientId?.businessName,
        },
        employee: {
          name: `${emp.firstName} ${emp.lastName}`,
          designation: emp.jobTitle,
          status: emp.status,
        },
        timesheetPeriod: { from: startDateStr, to: endDateStr },
        timesheetData: filledData,
        finalStandardTime: totalValue.st.toFixed(2),
        finalTotalBillableHours: totalValue.tbh.toFixed(2),
        finalTotalHours: totalValue.th.toFixed(2),
      };

      await handleTimesheetDownload(pdfData);

    } catch (error) {
      console.error("Error downloading timesheet:", error);
      showToast("Failed to download timesheet", "error");
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <div className="flex-1 w-full flex overflow-auto">
      {showReceivePayment ? (
        <ReceivePayment onBack={() => setShowReceivePayment(false)} />
      ) : showEdit ? (
        <EditInvoice
          onBack={() => setShowEdit(false)}
          currentInvoices={currentInvoices}
        />
      ) : (
        <div
          className="flex-1 flex flex-col overflow-auto pr-1"
          id="invoice-wrapper"
        >
          {/* Omkar new Design */}
          <div className="flex flex-col gap-6 my-1">
            <div className="inputShadow p-3 pt-0 flex flex-col gap-1">
              <QbAnimationLoading isOpen={isLoading} />
              {!removeButtonForPreview && (
                <div className="">
                  <Button
                    title="Back"
                    icon={"west"}
                    size="sm"
                    color="black"
                    variant="text"
                    className="!px-0 hover:bg-transparent"
                    onClick={onBack}
                  />
                </div>
              )}
              {isPublicView ? (
                /* Public View Custom Header */
                <div className="grid grid-cols-3 items-center">
                  <div className="flex justify-start mt-2">
                    <img
                      src={propCompanyLogo}
                      alt="Company Logo"
                      style={{ height: "60px", objectFit: "contain" }}
                    />
                  </div>
                  <div className="flex justify-center mt-2">
                    {(loginUserData?.organizationId?.logo?.company) && (
                        <img
                          src={loginUserData?.organizationId?.logo?.company}
                          alt="Organization Logo"
                          style={{ height: "64px", objectFit: "contain" }}
                        />
                      )}
                  </div>
                </div>
              ) : (
                /* Internal View Standard Header */
                <div className="flex justify-between items-center">
                  <div>
                    <InvoicesHeader
                      data={{
                        // logo: companyLogo,
                        title: "Tektree",
                        invoiceNumber: (
                          <span
                            style={{
                              background: "rgba(255, 190, 0, 0.2)",
                              padding: "2px 4px",
                              borderRadius: "4px",
                            }}
                          >
                            {currentInvoices?.invoiceNum}
                          </span>
                        ),
                        syncStatus: currentInvoices?.qbSync?.status || 1,
                        invoiceStatus:
                          currentInvoices?.status == 1 ? "Saved" : "Submitted",
                      }}
                    />
                  </div>
                  {/* <div className="min-w-60">
                    <InfoTimeCardAdv
                      title={
                        currentInvoices?.amounts?.due >= 0
                          ? "Total Due"
                          : "Excess Payment"
                      }
                      value={formatCurrency(currentInvoices?.amounts?.due) ?? 0}
                      prefix=""
                      suffix="USD"
                      color="primary"
                      size="xs-sm"
                    />
                  </div> */}
                  <DevNote className="text-xs space-y-1 text-gray-500">
                    {currentInvoices?.uiid && (
                      <div>
                        <span className="text-gray-400">UIID:</span> {currentInvoices.uiid}
                      </div>
                    )}
                  
                    {currentInvoices?.qbSync?.error && (
                      <div className="text-red-500">
                        QB Error: {currentInvoices.qbSync.error}
                      </div>
                    )}
                  
                    {currentInvoices?.qbSync?.id && (
                      <div>
                        <span className="text-gray-400">QB ID:</span> {currentInvoices.qbSync.id}
                      </div>
                    )}
                  
                    {currentInvoices?.qbSync?.status && (
                      <div>
                        <span className="text-gray-400">Status:</span> {currentInvoices.qbSync.status}
                      </div>
                    )}
                  
                    {currentInvoices?.qbSync?.lastSync && (
                      <div>
                        <span className="text-gray-400">Last Sync:</span>{" "}
                        {dateFormator(currentInvoices.qbSync.lastSync)}
                      </div>
                    )}
                  </DevNote>
                  <div className="min-w-60">
                    <InfoCardNewAdv
                      layout="option12"
                      title={
                        currentInvoices?.amounts?.due >= 0
                          ? "Total Due"
                          : "Excess Payment"
                      }
                      value={formatCurrency(currentInvoices?.amounts?.due) ?? 0}
                      valueConfig={{ className: "text-[20px]!" }}
                      suffix="USD"
                      suffixConfig={{className:"font-normal! mt-1!"}}
                    />
                  </div>
                </div>
              )}
              {!removeButtonForPreview && (
                <div className="flex justify-end gap-1.5" data-print="false">
                  <Button
                    size="sm"
                    variant="outlined"
                    color="black"
                    title={"Mail Sent"}
                    icon={"docs"}
                    onClick={() => navigate("/invoices/mail-sent")}
                  />
                  <Button
                    size="sm"
                    variant="outlined"
                    color="black"
                    title={"Update to QB"}
                    icon={"arrow_left_alt"}
                    // disabled={true}
                    onClick={() => handleQB("invoices")}
                  />
                  <Button
                    size="sm"
                    variant="outlined"
                    color="black"
                    title={"Sync from QB"}
                    icon={"autorenew"}
                    onClick={() => handleQbSync()}
                    // onClick={() => connectToQB()}
                    // onClick={() => setIsQbModalOpen(true)}
                  />
                  <Button
                    size="sm"
                    variant="outlined"
                    color="black"
                    title={"Void Invoice"}
                    icon={"block"}
                    onClick={() => setIsVoidModalOpen(!isVoidModalOpen)}
                  />
                  <Button
                    size="sm"
                    type="icon"
                    variant="outlined"
                    color="black"
                    icon={"delete"}
                    className="rounded-sm p-4 px-5 text-danger-200"
                  />
                  <Button
                    size="sm"
                    type="icon"
                    variant="outlined"
                    color="black"
                    icon={"south"}
                    onClick={invoiceDownloader}
                    className="rounded-sm p-4 px-5"
                  />
                  <Button
                    size="sm"
                    type="icon"
                    variant="outlined"
                    color="black"
                    icon={"visibility"}
                    className="rounded-sm p-4 px-5"
                    onClick={() => {
                      setViewModal(true);
                    }}
                  />
                </div>
              )}
            </div>
            <div className="grid grid-cols-2 gap-5">
              <HeaderCard
                title={"Bill To"}
                className="!bg-primary-50 !text-primary"
              >
                <KeyValue
                  oneLine={false}
                  label={currentInvoices?.clientId?.businessName || "-"}
                  value={
                    [
                      currentInvoices?.address?.billing?.address1,
                      currentInvoices?.address?.billing?.address2,
                      currentInvoices?.address?.billing?.city,
                      currentInvoices?.address?.billing?.state,
                      currentInvoices?.address?.billing?.country,
                      currentInvoices?.address?.billing?.zipCode,
                    ].filter(Boolean) // removes undefined/null values
                  }
                />
              </HeaderCard>

              <HeaderCard
                title={"Invoice Details"}
                className="!bg-primary-50 !text-primary"
              >
                <div className="flex flex-col gap-1">
                  <KeyValue
                    label={"Invoice"}
                    value={
                      <span
                        className="text-bold"
                        style={{
                          backgroundColor: "rgba(255, 190, 0, 0.2)",
                          padding: "2px 4px",
                          borderRadius: "4px",
                        }}
                      >
                        {currentInvoices?.invoiceNum}
                      </span>
                    }
                  />
                  <KeyValue
                    label="Invoice Date"
                    value={
                      currentInvoices?.invoiceDate
                        ? dateFormator(currentInvoices?.invoiceDate)
                        : ""
                    }
                  />
                  <KeyValue
                    label={"Shipped Date"}
                    value={
                      currentInvoices?.shippedDate
                        ? dateFormator(currentInvoices?.shippedDate)
                        : ""
                    }
                  />
                  <KeyValue
                    label={"Due Date"}
                    value={
                      currentInvoices?.dueDate
                        ? dateFormator(currentInvoices?.dueDate)
                        : ""
                    }
                  />
                  {/* <KeyValue label={"Class"} value={"Sukumar Mididodi"} /> */}
                  <KeyValue label={"Terms"} value={currentInvoices?.netTerms} />
                </div>
              </HeaderCard>
            </div>
            <div className="inputShadow p-3 w-full">
              <div className="shadow-md">
                <TableAdv
                  rows={mappedRows}
                  columns={columns}
                  hideToolBar
                  showSlNo
                />
              </div>
              <div className="flex justify-end ">
                <div className="my-2 grid grid-cols-[1fr_190px] gap-x-10 w-fit max-w-2xl text-sm ">
                  <div className="py-2">Subtotal</div>
                  <div className="py-2">
                    {formatCurrency(currentInvoices?.finalBill?.subTotal)}
                  </div>
                  <div className="col-span-2 border-t border-gray-200" />

                  {/* ///////////////final bill discounts/////////////////   */}
                  {/* {console.log(
                    "final bill discounts",
                    currentInvoices?.finalBill?.discounts,
                    currentInvoices?.finalBill?.subTotal,
                    typeof currentInvoices?.finalBill?.subTotal
                  )} */}
                  {currentInvoices?.finalBill?.discounts?.length > 0 && (
                    <>
                      {currentInvoices?.finalBill?.discounts
                        .map((discount, index) => (
                          <React.Fragment key={discount?._id || index}>
                            <div className="py-2">{discount?.name}</div>
                            <div className="py-2">
                              {discount?.type === 1
                                ? `-${formatCurrency(
                                    Math.round(
                                      Number(
                                        currentInvoices?.finalBill?.subTotal,
                                      ) * Number(discount.value),
                                    ) / 100,
                                  )}`
                                : `-${formatCurrency(discount?.value)}`}
                            </div>
                            <div className="col-span-2 border-t border-gray-200" />
                          </React.Fragment>
                        ))
                        .reverse()}
                    </>
                  )}
                  {/* ////////////////final bill discounts end////////////////   */}

                  <div className="py-2 font-medium">Invoice Total</div>
                  <div className="py-2 font-medium">
                    {formatCurrency(currentInvoices?.amounts?.invoiced)}
                  </div>
                  <div className="col-span-2 border-t border-gray-200" />

                  {/* ////////////////final bill discounts end////////////////   */}
                  {/* ////////////////payments////////////////   */}
                  {payments?.length > 0 && (
                    <div className="flex justify-end">
                      <div className="flex flex-col justify-end m-4 gap-2 min-w-[400px]">
                        {payments
                          .map((payment, index) => (
                            <div
                              key={payment?.Id || index}
                              className="flex w-full bg-white gap-12 "
                            >
                              <div className="flex-1 text-left px-8 py-2 text-blue-400 font-medium whitespace-nowrap">
                                {`Payment on ${new Date(
                                  payment?.TxnDate,
                                ).toLocaleDateString("en-US")}`}
                              </div>
                              <div className="flex-1 text-right px-4 py-2 text-gray-900">
                                -
                                {formatCurrency(Number(payment?.TotalAmt || 0))}
                              </div>
                            </div>
                          ))
                          .reverse()}
                      </div>
                    </div>
                  )}
                  {/* ////////////////payments end////////////////   */}
                  {/* ////////////////due////////////////   */}
                  {!isPublicView && currentInvoices?.amounts?.due > 0 && (
                    <>
                      <div className="py-2 text-primary text-base font-medium">
                        {" "}
                        Balance Due
                      </div>
                      <div className="py-2 text-primary text-base font-medium">
                        {formatCurrency(currentInvoices?.amounts?.due)}
                      </div>
                    </>
                  )}
                  {/* ////////////////due end////////////////   */}
                </div>
              </div>

              {/* <div className="">


                <div className="flex justify-end mt-4 my-2">
                  <div className="bg-black text-white  flex gap-4 min-w-[400px] ">
                    <div className="flex-1  justify-center text-left  border-white px-4 py-3 ">
                      Subtotal
                    </div>
                    <div className="w-px bg-white mx-2" />
                    <div className="flex-1 px-4 py-3 text-right">
                      {formatCurrency(currentInvoices?.finalBill?.subTotal)}
                    </div>
                  </div>
                </div>

                {console.log(
                  "final bill discounts",
                  currentInvoices?.finalBill?.discounts,
                  currentInvoices?.finalBill?.subTotal,
                  typeof currentInvoices?.finalBill?.subTotal
                )}
                {currentInvoices?.finalBill?.discounts?.length > 0 && (
                  <div className="flex justify-end">
                    <div className="flex flex-col justify-end m-4 gap-2 min-w-[400px]">
                      {currentInvoices?.finalBill?.discounts
                        .map((discount, index) => (
                          <div
                            key={discount?._id || index}
                            className="flex w-full bg-white gap-12 "
                          >
                            <div className="flex-1 text-left px-8 py-1  font-medium whitespace-nowrap ">
                              {discount?.name}
                            </div>
                            <div className="flex-1 text-right px-4 py-2 text-gray-900 ">
                              {discount?.type === 1
                                ? `-${formatCurrency(
                                    Math.round(
                                      Number(
                                        currentInvoices?.finalBill?.subTotal
                                      ) * Number(discount.value)
                                    ) / 100
                                  )}`
                                : `-${formatCurrency(discount?.value)}`}
                            </div>
                          </div>
                        ))
                        .reverse()}
                    </div>
                  </div>
                )}

                <div className="flex justify-end">
                  <div className="bg-black text-white  flex gap-4 min-w-[400px] ">
                    <div className="flex-1  justify-center text-left  border-white px-4 py-3">
                      Invoice Total
                    </div>
                    <div className="w-px bg-white mx-2" />
                    <div className="flex-1 px-4 py-3 text-right">
                      {formatCurrency(currentInvoices?.amounts?.invoiced)}
                    </div>
                  </div>
                </div>

                {payments?.length > 0 && (
                  <div className="flex justify-end">
                    <div className="flex flex-col justify-end m-4 gap-2 min-w-[400px]">
                      {payments
                        .map((payment, index) => (
                          <div
                            key={payment?.Id || index}
                            className="flex w-full bg-white gap-12 "
                          >
                            <div className="flex-1 text-left px-8 py-2 text-blue-400 font-medium whitespace-nowrap">
                              {`Payment on ${new Date(
                                payment?.TxnDate
                              ).toLocaleDateString("en-US")}`}
                            </div>
                            <div className="flex-1 text-right px-4 py-2 text-gray-900">
                              -{formatCurrency(Number(payment?.TotalAmt || 0))}
                            </div>
                          </div>
                        ))
                        .reverse()}
                    </div>
                  </div>
                )}

                {currentInvoices?.amounts?.due && (
                  <div className="flex justify-end mt-2">
                    <div className="bg-black text-white  flex gap-4 min-w-[400px] ">
                      <div className="flex-1  justify-center text-left  border-white px-4 py-3">
                        Balance Due
                      </div>
                      <div className="w-px bg-white mx-2 " />
                      <div className="flex-1 px-4 py-3 text-right">
                        {formatCurrency(currentInvoices?.amounts?.due)}
                      </div>
                    </div>
                  </div>
                )}
              </div> */}
            </div>
            {isPublicView && (
              <div className="flex justify-end mb-2 mx-4 gap-2" data-print="false">
                <Button
                    title="Download Timesheet"
                    onClick={() => timesheetDownloader()}
                    icon="download"
                    size="sm"
                    variant="contained"
                    color="primary"
                  />
                <Button
                  title="Download Invoice"
                  onClick={invoiceDownloader}
                  icon="download"
                  size="sm"
                  variant="contained"
                  color="primary"
                  // /disable the download button enale it when the profile photo nuplaod is working correctly
                  disabled={true}    
                />
              </div>
            )}
            {!isPublicView && (
              <>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
              <div className="inputShadow p-3 flex flex-col gap-2">
                <KeyValue
                  label={"Statement Memo"}
                  className="text-primary"
                  value={currentInvoices?.memo}
                />

                <KeyValue
                  label={"Statement Memo Period"}
                  className="text-primary"
                  value={[
                    exactUTCDate(currentInvoices?.memoPeriod?.from),
                    exactUTCDate(currentInvoices?.memoPeriod?.to),
                  ]
                    .filter(Boolean)
                    .map((d) => d)
                    .join(" - ")}
                />
              </div>
              <div className="inputShadow p-3 flex justify-between items-center">
                <div>
                  <Chip
                    className="cursor-pointer"
                    label={`Attachments:-${combineAttachments.length}`}
                    variant="text"
                    color="primary"
                    icon={"attach_file"}
                    iconPosition={"before"}
                    disabled={combineAttachments.length <= 0}
                    onClick={() => setAttachmentModal(!attachmentModal)}
                  />
                </div>
                <div data-print="false">
                  <Button
                    size="xs-sm"
                    title={"Add Attachment"}
                    disabled={true}
                  />
                </div>
              </div>
            </div>
            </>)}
            <div className="grid grid-cols-1 lg:grid-cols-2 items-end gap-2 lg:gap-5">
              <div className="w-fit min-w-full lg:min-w-[430px] xl:min-w-[530px]">
                <div className="border-[1px] border-neutrals-50 rounded-sm px-3 py-2 ">
                  <h6 className="font-medium ">Additional Info</h6>
                  <Divider />
                  <div className="mt-1  text-center py-3 max-w-[400px]">
                    {currentInvoices?.jobId?.invoices?.additionalInfo && (
                      <KeyValue
                        value={currentInvoices?.jobId?.invoices?.additionalInfo}
                      />
                    )}
                  </div>
                </div>
              </div>

              {!removeButtonForPreview && (
                <div
                  className="flex-1 flex justify-end gap-1 lg:gap-2"
                  data-print="false"
                >
                  <Button
                    title={"Receive Payment"}
                    size="sm"
                    variant="outlined"
                    onClick={() => setShowReceivePayment(true)}
                  />
                  <Button
                    title={"Edit"}
                    size="sm"
                    variant="outlined"
                    onClick={() => setShowEdit(true)}
                  />
                  <Button
                    title={"Cancel"}
                    size="sm"
                    variant="outlined"
                    onClick={onBack}
                  />
                  <Button
                    title={"Resend"}
                    size="sm"
                    onClick={() => setISResendModal(!isResendModal)}
                  />
                </div>
              )}
            </div>
          </div>
          {/* Omkar new Design end */}

          {/* <div className="flex justify-between">
            <QbAnimationLoading isOpen={isLoading} />
            <img
              src={companyLogo}
              alt=""
              width={150}
              className="justify-center m-10"
            />
            <InvoicesHeader
              data={{
                // logo: companyLogo,
                title: "Tektree",
                invoiceNumber: (
                  <span
                    className="font-bold"
                    style={{
                      background: "rgba(255, 190, 0, 0.2)",
                      padding: "2px 4px",
                      borderRadius: "4px",
                    }}
                  >
                    {currentInvoices?.invoiceNum}
                  </span>
                ),
                invoiceStatus:
                  currentInvoices?.status == 1 ? "Saved" : "Submit",
              }}
            />
          </div> */}

          {/* <div data-print="false"> */}

          {/* <div>
            <PageHeader
              Section={
                <div className="flex">
                  <InfoTimeCardAdv
                    title="Total Due"
                    value={formatCurrency(currentInvoices?.amounts?.due) ?? 0}
                    prefix=""
                    suffix="USD"
                    color="primary"
                    size="sm"
                  />
                </div>
              }
              RightSection={
                <div className="flex gap-3" data-print="false">
                  {!removeButtonForPreview && (
                    <>
                      <Button
                        size="sm"
                        title={"Back"}
                        icon={"arrow_left_alt"}
                        onClick={onBack}
                      />
                      <Button
                        size="sm"
                        title={"Mail Sent"}
                        icon={"docs"}
                        onClick={() => navigate("/invoices/mail-sent")}
                      />
                      <Button
                        size="sm"
                        title={"Update to QB"}
                        icon={"arrow_left_alt"}
                        onClick={() => handleQB("invoices")}
                        // onClick={() => connectToQB()}
                        // onClick={() => setIsQbModalOpen(true)}
                      />
                      <Button
                        size="sm"
                        title={"Sync to QB"}
                        icon={"arrow_left_alt"}
                        onClick={() => handleQbSync()}
                        // onClick={() => connectToQB()}
                        // onClick={() => setIsQbModalOpen(true)}
                      />
                      <Button
                        size="sm"
                        title={"Void"}
                        onClick={() => setIsVoidModalOpen(!isVoidModalOpen)}
                      />

                      <Button
                        size="sm"
                        title={"Delete"}
                        onClick={() => setIsDeleteModalOpen(!isDeleteModalOpen)}
                      />

                      <div className="hidden">
                        <Button
                          // type="link"
                          icon="print"
                          size="sm"
                          variant="text"
                          color="info"
                          title={"Invoice PDF"}
                          // onClick={() => downloadInvoice()}
                          onClick={() => printInvoice()}
                        />
                      </div>
                      <div className="">
                        <Button
                          // type="link"
                          icon="download"
                          size="sm"
                          variant="text"
                          color="info"
                          title={"Invoice PDF"}
                          // onClick={() => downloadInvoice()}
                          onClick={() => downloadInvoice()}
                        />
                      </div>
                      <div className="">
                        <Button
                          // type="link"
                          icon="visibility"
                          size="sm"
                          variant="text"
                          color="info"
                          title={"View Invoice PDF"}
                          // onClick={() => handlePrintInvoice(currentInvoices)}
                          // onClick={() => generatePDF("view")}
                          onClick={() => viewInvoice()}
                        />
                      </div>
                    </>
                  )}
                </div>
              }
            />
          </div> */}

          {/* <div className="flex gap-3 mt-3 ">
            <HeaderCard title={"From"}>
              <KeyValue
                oneLine={false}
                label={"TekTree LLC"}
                value={
                  [
                    currentInvoices?.address?.from?.city,
                    currentInvoices?.address?.from?.state,
                    currentInvoices?.address?.from?.country,
                    currentInvoices?.address?.from?.zipCode,
                  ].filter(Boolean) // removes undefined/null values
                }
              />
            </HeaderCard>
            <HeaderCard title={"To"}>
              <KeyValue
                oneLine={false}
                label={currentInvoices?.clientId?.businessName || "-"}
                value={
                  [
                    currentInvoices?.address?.billing?.city,
                    currentInvoices?.address?.billing?.state,
                    currentInvoices?.address?.billing?.country,
                    currentInvoices?.address?.billing?.zipCode,
                  ].filter(Boolean) // removes undefined/null values
                }
              />
            </HeaderCard>
            <HeaderCard title={"Invoice Details"}>
              <div className="flex flex-col gap-1">
                <KeyValue
                  label={"Invoice"}
                  value={
                    <span
                      className="text-bold"
                      style={{
                        backgroundColor: "rgba(255, 190, 0, 0.2)",
                        padding: "2px 4px",
                        borderRadius: "4px",
                      }}
                    >
                      {currentInvoices?.invoiceNum}
                    </span>
                  }
                />
                <KeyValue
                  label="Invoice Date"
                  value={
                    currentInvoices?.invoiceDate
                      ? dateFormator(currentInvoices?.invoiceDate)
                      : ""
                  }
                />
                <KeyValue
                  label={"Shipped Date"}
                  value={
                    currentInvoices?.shippedDate
                      ? dateFormator(currentInvoices?.shippedDate)
                      : ""
                  }
                />
                <KeyValue
                  label={"Due Date"}
                  value={
                    currentInvoices?.dueDate
                      ? dateFormator(currentInvoices?.dueDate)
                      : ""
                  }
                />

                <KeyValue label={"Terms"} value={currentInvoices?.netTerms} />
              </div>
            </HeaderCard>
          </div> */}

          {/* <div className="mt-3 overflow-x-auto">
            <NewTable
              rows={mappedRows}
              columns={columns}
              hideToolBar
              showSlNo
            />
          </div> */}
          {/* <div className="mr-4">
            <div className="flex justify-end mt-4 my-2">
              <div className="bg-black text-white  flex gap-4 min-w-[400px] ">
                <div className="flex-1  justify-center text-left  border-white px-4 py-3 ">
                  Subtotal
                </div>
                <div className="w-px bg-white mx-2" />
                <div className="flex-1 px-4 py-3 text-right">
                  {formatCurrency(currentInvoices?.finalBill?.subTotal)}
                </div>
              </div>
            </div>

            {console.log(
              "final bill discounts",
              currentInvoices?.finalBill?.discounts,
              currentInvoices?.finalBill?.subTotal,
              typeof currentInvoices?.finalBill?.subTotal
            )}
            {currentInvoices?.finalBill?.discounts?.length > 0 && (
              <div className="flex justify-end">
                <div className="flex flex-col justify-end m-4 gap-2 min-w-[400px]">
                  {currentInvoices?.finalBill?.discounts
                    .map((discount, index) => (
                      <div
                        key={discount?._id || index}
                        className="flex w-full bg-white gap-12 "
                      >

                        <div className="flex-1 text-left px-8 py-1  font-medium whitespace-nowrap ">
                          {discount?.name}
                        </div>
                        <div className="flex-1 text-right px-4 py-2 text-gray-900 ">
                          {discount?.type === 1
                            ? `-${formatCurrency(
                                Math.round(
                                  Number(currentInvoices?.finalBill?.subTotal) *
                                    Number(discount.value)
                                ) / 100
                              )}`
                            : `-${formatCurrency(discount?.value)}`}
                        </div>
                      </div>
                    ))
                    .reverse()}
                </div>
              </div>
            )}

            <div className="flex justify-end">
              <div className="bg-black text-white  flex gap-4 min-w-[400px] ">
                <div className="flex-1  justify-center text-left  border-white px-4 py-3">
                  Invoice Total
                </div>
                <div className="w-px bg-white mx-2" />
                <div className="flex-1 px-4 py-3 text-right">
                  {formatCurrency(currentInvoices?.amounts?.invoiced)}
                </div>
              </div>
            </div>

            {payments?.length > 0 && (
              <div className="flex justify-end">
                <div className="flex flex-col justify-end m-4 gap-2 min-w-[400px]">
                  {payments
                    .map((payment, index) => (
                      <div
                        key={payment?.Id || index}
                        className="flex w-full bg-white gap-12 "
                      >
                        <div className="flex-1 text-left px-8 py-2 text-blue-400 font-medium whitespace-nowrap">
                          {`Payment on ${new Date(
                            payment?.TxnDate
                          ).toLocaleDateString("en-US")}`}
                        </div>
                        <div className="flex-1 text-right px-4 py-2 text-gray-900">
                          -{formatCurrency(Number(payment?.TotalAmt || 0))}
                        </div>
                      </div>
                    ))
                    .reverse()}
                </div>
              </div>
            )}


            {currentInvoices?.amounts?.due && (
              <div className="flex justify-end mt-2">
                <div className="bg-black text-white  flex gap-4 min-w-[400px] ">
                  <div className="flex-1  justify-center text-left  border-white px-4 py-3">
                    Balance Due
                  </div>
                  <div className="w-px bg-white mx-2 " />
                  <div className="flex-1 px-4 py-3 text-right">
                    {formatCurrency(currentInvoices?.amounts?.due)}
                  </div>
                </div>
              </div>
            )}
          </div> */}

          {/* <div className="flex flex-col gap-2">
            <KeyValue label={"Statement Memo"} value={currentInvoices?.memo} />
            <KeyValue
              label={"Statement Memo Period"}
              // value={"Ramesh Manthri (02/01/2025 To 02/28/2025)"}
              value={[
                dateFormator(currentInvoices?.memoPeriod?.from),
                dateFormator(currentInvoices?.memoPeriod?.to),
              ]
                .filter(Boolean)
                .map((d) => d)
                .join(" - ")}
            />
            <div className="flex">
              <div className="border-[1px] border-neutrals-50 rounded-sm px-3 py-2 ">
                <h6 className="font-medium ">Additional Info</h6>
                <Divider />
                <div className="mt-1  text-center py-3 max-w-[400px]">
                  {console.log(
                    "currentInvoices for additioal info",
                    currentInvoices?.jobId?.invoices?.additionalInfo
                  )}
                  {currentInvoices?.jobId?.invoices?.additionalInfo && (
                    <KeyValue
                      // value={[
                      //   "This Invoice has been Sold & Assigned to",
                      //   "Tek Tree LLC",
                      //   "Remit payment only to:",
                      //   "P.O Box #799",
                      //   "Gloucester, VA - 23061",
                      //   "C/O Chesapeake Bank",
                      //   "Chesapeake Bank",
                      // ]}
                      value={currentInvoices?.jobId?.invoices?.additionalInfo}
                    />
                  )}
                </div>
              </div>
            </div>
            <div className="mt-4" data-print="false">
              <PageHeader
                Section={
                  <div className="flex">
                    <PageTitle title={"ATTACHMENTS"} tag="p" />
                  </div>
                }
              />
              <Divider />
              <div className="mt-1 mb-4">
                <div className="flex gap-1">

                  <div className="flex gap-3 mt-2">

                    <div
                      className="bg-info-50 flex rounded-md items-center cursour-pointer"
                      onClick={() => setAttachmentModal(!attachmentModal)}
                    >
                      <Chip
                        label={`Attachments:-${combineAttachments.length}`}
                        icon={"docs"}
                        iconPosition={"before"}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="mb-4" data-print="false">
              <PageHeader
                RightSection={
                  <div className="flex">
                    {!removeButtonForPreview && (
                      <div className="flex gap-3">
                        <Button
                          size="sm"
                          title={"Receive Payment"}
                          onClick={() => setShowReceivePayment(true)}
                        />
                        <Button
                          size="sm"
                          title={"Resend"}
                          onClick={() => setISResendModal(!isResendModal)}
                        />
                        <Button
                          size="sm"
                          title={"Edit"}
                          // onClick={() => setEditInvoice(true)}
                          onClick={() => setShowEdit(true)}
                        />
                        <Button size="sm" title={"Cancel"} />
                      </div>
                    )}
                  </div>
                }
              />
            </div>
            <div data-print="false" className="hidden">
              <PageHeader
                Section={
                  <div className="flex">
                    <PageTitle title={"ACTIVITIES"} tag="p" />
                  </div>
                }
              />
              <Divider />
              <div className=" mt-4">
                <NewTable
                  rows={activityRows}
                  columns={activityColumns}
                  hideToolBar
                />
              </div>
            </div>
          </div> */}
          <QbModal
            invoiceNumber={currentInvoices?.invoiceNum}
            open={isQbModalOpen}
            onClose={() => setIsQbModalOpen(false)}
          />
          <VoidModal open={isVoidModalOpen} onClose={closeVoidModal} />
          <DeleteConformationModal
            open={isDeleteModalOpen}
            onClose={() => setIsDeleteModalOpen(!isDeleteModalOpen)}
          />
          {isResendModal && (
            <ResendModal
              open={isResendModal}
              onClose={() => setISResendModal(!isResendModal)}
              toEmail={
                currentInvoices?.clientId?.roleContacts
                  ?.filter((data) => data.role === "Accounts")
                  ?.flatMap((item) => item.email) || []
              }
              ccEmail={currentInvoices?.jobId?.invoices?.cc || []}
              data={{
                orgLogo: loginUserData?.organizationId?.logo?.company || "",
                orgName: loginUserData?.organizationId?.name || "",
                invoiceNum: currentInvoices?.invoiceNum || "",
                client: currentInvoices?.clientId?.businessName || "",
                dueDate: dateFormator(currentInvoices?.dueDate) || "",
                invoiceDate: dateFormator(currentInvoices?.dueDate),
                amount:
                  formatCurrency(currentInvoices?.amounts?.invoiced) || "",
                // invoiceUrl:
                //   import.meta.env.VITE_APP_ENV === "production"
                //     ? "https://tektree.kultworks.ai/invoices#all-invoices"
                //     : "https://staging.kultworks.ai/invoices#all-invoices",
                 invoiceUrl: `${window.location.origin}/view/${loginUserData?.organizationId?.uiid}/${currentInvoices?._id}`,
              }}
              templateName="invoice_created"
              emailSubject={"Invoice Update"}
              handleSave={handleSendMail}
              isMailSaving={isMailLoading}
            />
          )}
          <Modal
            isOpen={attachmentModal}
            onClose={() => setAttachmentModal(false)}
            // title="Attachment View"
            // width="max-w-5xl"
            width="max-w-2xl"
            title={"Document Details"}
          >
            {/* <div className="flex flex-col justify-center items-center gap-8">
              <h6>attachement Details</h6> */}
            <DocumentsList data={combineAttachments} />
            {/* <Button
                title={"Close"}
                onClick={() => setAttachmentModal(false)}
              /> */}
            {/* </div> */}
          </Modal>
          <Modal
            isOpen={viewModal}
            onClose={() => setViewModal(false)}
            closeOnOutsideClick={true}
            width="max-w-6xl"
            title="View Invoice"
          >
            {viewModal &&
              (() => {
                const invoiceObj = {
                  company: {
                    name: "TekTree LLC",
                    address:
                      [
                        currentInvoices?.address?.from?.address1,
                        currentInvoices?.address?.from?.address2,
                        currentInvoices?.address?.from?.city,
                        currentInvoices?.address?.from?.state,
                        currentInvoices?.address?.from?.country,
                        currentInvoices?.address?.from?.zipCode,
                      ]
                        ?.filter(Boolean)
                        ?.join(", ") || "-",
                    contact: "+1 (123) 456-7890",
                    email: "accounts@tektreeinc.com",
                    website: "www.tektreeinc.com",
                    companyLogo:
                      loginUserData?.organizationId?.logo?.company || "",
                    backgroundLogo:
                      loginUserData?.organizationId?.logo?.company || "",
                    additionalInfo: currentInvoices?.additionalInfo || "",
                  },
                  invoiceDeta: {
                    amounts: {
                      invoiced: currentInvoices?.amounts?.invoiced || 0,
                      due: currentInvoices?.amounts?.due || 0,
                    },
                    name: currentInvoices?.clientId?.businessName || "-",
                    address:
                      [
                        currentInvoices?.address?.billing?.address1,
                        currentInvoices?.address?.billing?.address2,
                        currentInvoices?.address?.billing?.city,
                        currentInvoices?.address?.billing?.state,
                        currentInvoices?.address?.billing?.country,
                        currentInvoices?.address?.billing?.zipCode,
                      ]
                        ?.filter(Boolean)
                        ?.join(", ") || "-",
                    invoiceNumber: currentInvoices?.invoiceNum || "-",
                    invoiceDate: currentInvoices?.invoiceDate || "-",
                    shippedDate: currentInvoices?.shippedDate || "-",
                    netTerms: currentInvoices?.netTerms || "-",
                    dueDate: currentInvoices?.dueDate || "-",
                    invoicedItems:
                      currentInvoices?.serviceSummary?.map((data) => ({
                        item: data?.activity || "-",
                        description: data?.ss || "-",
                        quantity: data?.quantity || 0,
                        price: data?.rate || 0,
                        discount: 0,
                      })) || [],
                  },
                };
                const subTotal = invoiceObj?.invoiceDeta?.invoicedItems.reduce(
                  (sum, item) =>
                    sum + (item.quantity * item.price - (item.discount || 0)),
                  0,
                );

                const updatedData = {
                  ...invoiceObj,
                  invoiceDeta: {
                    ...invoiceObj?.invoiceDeta,
                    subTotal: subTotal,
                    discountTotal:
                      invoiceObj?.invoiceDeta?.amounts?.invoiced - subTotal ||
                      0,
                    invoiceTotal:
                      invoiceObj?.invoiceDeta?.amounts?.invoiced || 0,
                    dueTotal: invoiceObj?.invoiceDeta?.amounts?.due || 0,
                    currency: "USD",
                  },
                };
                return (
                  <PdfGenerator
                    data={updatedData}
                    items={updatedData.invoiceDeta?.invoicedItems || []}
                    header={<InvoiceHeader data={updatedData} />}
                    headerTwo={<InvoiceHeader data={updatedData} type="sub" />}
                    contentTop={
                      <InvoiceContent data={updatedData} type="top" />
                    }
                    contentBottom={
                      <InvoiceContent data={updatedData} type="bottom" />
                    }
                    tableHeader={<TableHeader />}
                    rowRenderer={(item, index) => InvoiceData(item, index)}
                    footer={<InvoiceFooter data={updatedData} />}
                    footerTwo={<InvoiceFooter data={updatedData} type="sub" />}
                    backgroundLogo={updatedData?.company?.backgroundLogo}
                    fileName={`Invoice-${
                      updatedData.invoiceDeta?.invoiceNumber || ""
                    }`}
                  />
                );
              })()}
          </Modal>
        </div>
      )}
      <Backdrop isOpen={paymentsLoading || isDownloading}>
        <LogoLoader />
      </Backdrop>
    </div>
    // <div className="bg-red-100 flex-1">
    //   asdf
    //   <Button size="sm" title={"Back"} onClick={() => onBack()} />
    // </div>
  );
};

export default InvoiceDetails;
